/**
 * A function that sanitizes input element values.
 * @param {String} value the input value for sanitizing
 * @returns the new sanitized value.
 */
export const sanitize = (value) => value.replace(/(<([^>]+)>)|(alert\(")|("\))/gi, '');
/**
 * Escapes special characters in a Regex match.
 * @param {String} value the value to escape
 * @returns the new sanitized value
 */
export const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
/**
 * Utility for sanitizing search values.
 *
 * Note: Encode values first in case string contains invalid characters like "%" that will break page rendering.
 */
export const XSS = {
    regex: /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/ig,
    chars: /(<\s*)|(>\s*)|(\$\s*)|(\/\s*)|(\(\s*)|(\)\s*)|(:\s*)|(%\s*)|(@\s*)|(\*\s*)|(\^\s*)|(\{\s*)|(}\s*)/ig,
    is(str) {
        return this.regex.test(decodeURIComponent(encodeURIComponent(str)));
    },
    hasChars(str) {
        return this.chars.test(decodeURIComponent(encodeURIComponent(str)));
    },
    sanitize(input) {
        return decodeURIComponent(encodeURIComponent(input)).replace(/(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script|(<\s*)|(>\s*)|(\$\s*)|(\/\s*)|(\(\s*)|(\)\s*)|(:\s*)|(%\s*)|(@\s*)|(\*\s*)|(\^\s*)|(\{\s*)|(}\s*)/ig, '');
    },
};
//# sourceMappingURL=sanitize.js.map